module.exports = __webpack_public_path__ + "img/banner3.a7afed10.png";